<template>
    <div class="container m-0-a">
        <div class="guide-top-pic p-r" :style="{backgroundImage: 'url(' + guideTopInfo.head_bg + ')' }">
            <div class="go d-i-b p-a" v-if="guideTopInfo.btn_go" @click="orderSite">
                <img :src="guideTopInfo.btn_go" alt="">
            </div>
        </div>
        <div :class="[{'has-margin-bottom':isMobile},'session-second-wrap']">
            <guide-tab :info='tabInfo' :gameCode="gameCode" :fontInfo="fontInfo" @chooseBar="chooseBar"></guide-tab>
            <guide-search :info='searchInfo' @search="search"></guide-search>
            <guide-article :info='articleInfo' :fontInfo="fontInfo"></guide-article>
            <page-divide :info='pageInfo' @change="pageChange" :key="pageInfo.total" v-if="pageInfo.total"></page-divide>
            <foot></foot>
        </div>
        <mb-bar :info="barInfo" :lan="language" v-if="barInfo"></mb-bar>
        <loading v-if="loading"></loading>
    </div>
</template>
<style lang="less" scoped>
    .container {
        .go {
            width: 2.8rem;
            height: .8rem;
            bottom: .4rem;
            left: 70%;
        }
        .guide-top-pic {
            height: 6.16rem;
            background-size: cover;
            background-position: center center;
        }
        .session-second-wrap {
            background: #fff;
        }
        .has-margin-bottom {
            margin-bottom: 1.33333rem;
        }
    }
    @media screen and (min-width:1025px) {
        [pc="1"] .guide-top-pic {
            height: 462px;
            background-size: 100% 100%;
        }
        [pc="1"] .go {
            width: 210px;
            height: 60px;
            bottom: 30px;
            left: 60%;
        }
    }
</style>

<script>
    import Util from "@util/index.js"
    import controller from "@controller/guide.js"
    import topDes from '@components/index/top-des'
    import videoDes from '@components/index/video-des'
    import guideTab from '@components/guide/guide-tab.vue'
    import guideSearch from '@components/guide/guide-search.vue'
    import guideArticle from '@components/guide/guide-article.vue'
    import pageDivide from '@components/guide/page-divide.vue'
    import foot from '@components/common/foot/index.vue'
    import mbBar from '@components/common/bar/index.vue'
    import loading from '@components/common/loading/index.vue'
    export default {
        components: {
            guideTab,
            guideSearch,
            guideArticle,
            pageDivide,
            foot,
            mbBar,
            loading
        },
        asyncData(payload) {
            try{
                
            if (process.server) {
                const dataInfo = payload['payload']['picData'];
                const info = controller.initPic(dataInfo.list);
                const barInfo = controller.initBarInfo(dataInfo.gameItemInfo, payload['payload'].webMark, payload['payload'].isPreference, payload['payload'].lan, payload['payload'].testPath);
                const topBar = controller.initTopBar(dataInfo.gameItemInfo, payload['payload'].webMark);
                const pcBarInfo = controller.getPCBarInfo(dataInfo.list, payload['payload'].isPreference, payload['payload'].lan)
                console.log('......      攻略页面接收到的语言            .........' + payload['payload'].language)
                console.log('......      攻略页面的标题打印开始            .........')
                console.log(JSON.stringify(topBar))
                console.log('......      攻略页面的标题打印结束            .........')
                return {
                    faviconIcon: payload['payload'].faviconIcon,
                    seoInfo: payload['payload'].seoInfo,
                    gameCode: payload['payload'].gameCode,
                    lan: payload['payload'].lan,
                    language: payload['payload'].language,
                    guideTopInfo: info.guideTopInfo,
                    searchInfo: info.searchInfo,
                    tabInfo: topBar,
                    fontInfo: {
                        normalColor: topBar.normalBg,
                        activeColor: topBar.activeBg,
                    },
                    barInfo: Object.assign({
                        path: 'guide'
                    }, barInfo, pcBarInfo),
                    pageInfo: {
                        pageSize: 10, //每页显示10条数据
                        pageIndex: 1, //当前页码
                        total: 0, //总数据
                        pagestyle: {
                            bgColor: topBar.activeBg,
                            color: '#fff',
                            activeBgColor: topBar.activeBg,
                        }
                    }
                }
            }
            }catch(e){
                console('guide错误'+e)
            }
            
            
        },
        data() {
            return {
                isMobile: false,
                loading: false,
                searchWord: (this.lan != 'zh' && this.lan != 'zhhk') ? 'newbie' : '新手',
                articleInfo: []
            }
        },
        head() {
            return {
                title: this.seoInfo.title,
                link: [{
                    rel: 'icon',
                    href: this.faviconIcon
                }, ],
                meta: [{
                        'property': 'og:url',
                        name: 'url',
                        content: this.seoInfo.url
                    },
                    {
                        'property': 'og:image',
                        name: 'image',
                        content: this.seoInfo.image
                    },
                    {
                        'property': 'og:title',
                        name: 'title',
                        content: this.seoInfo.title
                    },
                    {
                        'property': 'og:description',
                        name: 'description',
                        content: this.seoInfo.description
                    },
                    {
                        'property': 'og:keywords',
                        name: 'keywords',
                        content: this.seoInfo.keyword
                    }
                ]
            }
        },
        mounted() {
            this.loading = true;
            Util.deviceType() == 'mb' ? this.isMobile = true : this.isMobile = false;
            this.searchWord = this.tabInfo.tab[0].value;
            this.getNewsInfo();

            Util.addSesstion('gameCode', this.gameCode);
            Util.addSesstion('ga-id', this.seoInfo.ga);
        },
        methods: {
            // 没有配置链接就弹窗配置的提醒
            orderSite() {
                if (this.guideTopInfo.btn_link == '') {
                    alert(this.guideTopInfo.author)
                } else {
                    window.location.href = guideTopInfo.btn_link;
                }
                Util.trackGA('点击', this.language + '攻略页的立即前往按钮', this.language + '攻略页的立即前往按钮');
            },
            //从page组件传递过来的当前_index,请求该页码数据。
            pageChange(_index) {
                this.loading = true;
                this.pageInfo.pageIndex = _index;
                this.getNewsInfo();
            },
            chooseBar(_info) {
                this.loading = true;
                this.searchWord = _info.value;
                this.pageInfo.pageIndex = 1;
                this.getNewsInfo();
            },
            search(_word) {
                this.loading = true;
                this.pageInfo.pageIndex = 1;
                this.searchWord = _word;
                this.searchNewsInfo();
            },
            setNews(_info) {
                this.articleInfo = [];
                _info.forEach(ele => {
                    let id = `news_${ele.id.split('newsInfo_')[1]}`;
                    this.articleInfo.push({
                        title: ele.title,
                        path: `/${this.lan}/pages/${id}.html`,
                        type: ele.keyword,
                        id: ele.id
                    })
                })
            },
            getNewsInfo() {
                let queryField = '';
                if (this.lan != 'zh' && this.lan != 'zhhk') {
                    queryField = "_" + this.language;
                }
                const params = {
                    table: 't_pf_esdata',
                    mustCondition: '{"gameCode":"' + this.gameCode + '","category":"0"}',
                    word: this.searchWord,
                    queryField: '{"keyword":1}',
                    //  queryField: '{"keyword":1,"title' + queryField + '":1,"content' + queryField + '":1}',
                    shouldCondition: '',
                    language: this.language,
                    returnFields: 'htmlpathurl,title' + queryField + ',keyword,id',
                    sortOrder: '{"createTime":"desc"}',
                    pageSize: this.pageInfo.pageSize,
                    pageNo: this.pageInfo.pageIndex,
                    crossdomain: true
                }
                const url = 'https://esou.efun.com/pf/news.shtml';
                Util.getInfo(url, params).then(data => {
                    data[0]['data']['datas'].length > 0 ? this.setNews(data[0]['data']['datas']) : this.articleInfo = [];
                    this.pageInfo.total = data[0]['data'].total;
                    this.loading = false;
                });
            },
            searchNewsInfo() {
                let queryField = '';
                if (this.lan != 'zh' && this.lan != 'zhhk') {
                    queryField = "_" + this.language;
                }
                const params = {
                    table: 't_pf_esdata',
                    mustCondition: '{"gameCode":"' + this.gameCode + '","category":"0"}',
                    word: this.searchWord,
                    // queryField: '{"keyword":1}',
                    queryField: '{"keyword":1,"title' + queryField + '":1,"content' + queryField + '":1}',
                    shouldCondition: '',
                    language: this.language,
                    returnFields: 'htmlpathurl,title' + queryField + ',keyword,id',
                    sortOrder: '{"createTime":"desc"}',
                    pageSize: this.pageInfo.pageSize,
                    pageNo: this.pageInfo.pageIndex,
                    crossdomain: true
                }
                const url = 'https://esou.efun.com/pf/news.shtml';
                Util.getInfo(url, params).then(data => {
                    data[0]['data']['datas'].length > 0 ? this.setNews(data[0]['data']['datas']) : this.articleInfo = [];
                    this.pageInfo.total = data[0]['data'].total;
                    this.loading = false;
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// client/smsgz/pages/guide.vue